export enum JobStatusEnum {
	PENDING = 'PENDING',
	IN_PROGRESS = 'IN_PROGRESS',
	SUCCESSFUL = 'SUCCESSFUL',
	FAILED = 'FAILED',
	SKIPPED = 'SKIPPED',
	NOT_CREATED = 'NOT_CREATED',
}
